import { Link } from "react-router-dom";
import cn from "classnames";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageFront.module.scss";

function PageFront() {
  const getImgSet = useImgSet();

  const sun = getImgSet("sun", "png", s.sun);
  const clouds = getImgSet("clouds", "png", s.clouds);
  const houseLarge = getImgSet("house__large", "png", s.house__large);
  const heroHeader = getImgSet("hero_header", "png", s.hero_header);

  const bear01 = getImgSet("bear__01", "png");
  const bear02 = getImgSet("bear__02", "png");
  const bear03 = getImgSet("bear__03", "png");
  const bear04 = getImgSet("bear__04", "png");
  const bear05 = getImgSet("bear__05", "png");

  const logoFooter = getImgSet("logo__footer");

  return (
    <div className={s.root}>
      <div className={s.back}>
        <div className={s.sky} />
      </div>
      <div className={s.inner}>
        {sun}
        {clouds}
        {houseLarge}
        {heroHeader}
        <div className={s.bears}>
          <Link to="/father/" className={cn([s.bear, s.bear__01])}>
            {bear01}
          </Link>
          <Link to="/mother/" className={cn([s.bear, s.bear__02])}>
            {bear02}
          </Link>
          <Link to="/kid/" className={cn([s.bear, s.bear__03])}>
            {bear03}
          </Link>
          <Link to="/cousin/" className={cn([s.bear, s.bear__04])}>
            {bear04}
          </Link>
          <Link to="/cousin/" className={cn([s.bear, s.bear__05])}>
            {bear05}
          </Link>
        </div>
      </div>
      <div className={s.footer}>{logoFooter}</div>
    </div>
  );
}

export default PageFront;
